module.exports = __webpack_public_path__ + "img/barre-9.3822483c.png";